import { Action, Selector, State, StateContext, createSelector } from '@ngxs/store';
import { HideLoadingSite, SetInitalizedSite, ShowLoadingSite, ToggleMenuSite, ToggleOffcanvasSite } from './site.actions';
import { Injectable } from '@angular/core';
import { SiteStateModel } from './site.model';

@State<SiteStateModel>({
  name: 'SiteState',
  defaults: {
    loading: true,
    initialized: false,
    menuShown: true,
    offcanvasShown: false,
  },
})
@Injectable()
export class SiteState {
  /* ======================================
  SELECTORS
  ====================================== */
  @Selector([SiteState])
  static isInitalized(state: SiteStateModel): boolean {
    return state.initialized;
  }

  @Selector([SiteState])
  static isLoading(state: SiteStateModel): boolean {
    return state.loading;
  }

  static isMenuShown() {
    return createSelector([SiteState], (state: SiteStateModel | undefined | null) => {
      return state?.menuShown ?? true;
    });
  }

  static isOffcanvasShown() {
    return createSelector([SiteState], (state: SiteStateModel | undefined | null) => {
      return state?.offcanvasShown ?? false;
    });
  }

  /* ======================================
  ACTIONS
  ====================================== */
  @Action(SetInitalizedSite)
  setInitalized(context: StateContext<SiteStateModel>) {
    context.patchState({
      initialized: true,
    });
  }

  @Action(ToggleMenuSite)
  toggleMenu(context: StateContext<SiteStateModel>) {
    const state = context.getState();
    context.patchState({
      menuShown: !state.menuShown,
    });
  }

  @Action(ToggleOffcanvasSite)
  toggleOffcanvas(context: StateContext<SiteStateModel>, { close }: ToggleOffcanvasSite) {
    const state = context.getState();
    context.patchState({
      offcanvasShown: close ? false : !state.offcanvasShown,
    });
  }

  @Action(ShowLoadingSite)
  showLoading(context: StateContext<SiteStateModel>) {
    context.patchState({
      loading: true,
    });
  }

  @Action(HideLoadingSite)
  hideLoading(context: StateContext<SiteStateModel>) {
    context.patchState({
      loading: false,
    });
  }
}
